// Initial search values
export const searchValues = {
  searchKey: "",
  fromDate: "",
  toDate: "",
};
